(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q4": function() { return /* binding */ useInsertBlueSpaceWithSchool; },
/* harmony export */   "dm": function() { return /* binding */ useAllBlueSpacesQuery; },
/* harmony export */   "p2": function() { return /* binding */ useUpdateBlueSpaceWithSchool; }
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8806);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6812);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(319);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query AllBlueSpaces {\n    blue_spaces {\n      id\n      lat\n      lng\n      school {\n        id\n        name\n        signed_manifesto\n        action_plan\n        marine_citizenship\n        marine_identity\n        deep_confidence\n        blue_job\n        memory_maps(\n          limit: 1\n        ) {\n          id\n        }\n        sit_spots(\n          limit: 1\n        ) {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  mutation InsertBlueSpaceWithSchoolMutation(\n    $lat: float8!, \n    $lng: float8!, \n    $schoolName: String!,\n    $schoolWebsite: String!,\n    $name: String!,\n    $optIn: timestamptz,\n    $optInOct: timestamptz,\n    $userId: Int!,\n  ) {\n    insert_blue_spaces_one(\n      object: {\n        lat: $lat, \n        lng: $lng, \n        school: {\n          data: {\n            name: $schoolName,\n            website: $schoolWebsite\n          }\n        }\n      }\n    ) {\n      school {\n        id\n        name\n      }\n      id\n      lat\n      lng\n    }\n\n    update_users_by_pk(\n      pk_columns: {\n        id: $userId\n      }, \n      _set: {\n        name: $name\n        opt_in: $optIn\n        opt_in_oct: $optInOct\n      }\n    ) {\n      id\n      name\n      opt_in\n      opt_in_oct\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  mutation UpdateBlueSpaceWithSchoolMutation(\n    $lat: float8!, \n    $lng: float8!, \n    $schoolName: String!,\n    $schoolWebsite: String!,\n    $name: String!,\n    $optIn: timestamptz,\n    $shouldUpdateOptIn: Bool,\n    $optInOct: timestamptz,\n    $shouldUpdateOptInOct: Bool,\n    $userId: Int!,\n    $schoolId: Int!,\n    $blueSpaceId: Int!\n  ) {\n    update_blue_spaces_by_pk(\n      pk_columns: {\n        id: $blueSpaceId\n      }, \n      _set: {\n        lat: $lat, \n        lng: $lng, \n      }\n    ) {\n      id\n      lat\n      lng\n    }\n\n    update_schools_by_pk(\n      pk_columns: {\n        id: $schoolId\n      }, \n      _set: {\n        name: $schoolName,\n        website: $schoolWebsite\n      }\n    ) {\n      id\n      name\n    }\n\n    update_users_by_pk(\n      pk_columns: {\n        id: $userId\n      }, \n      _set: {\n        name: $name\n      }\n    ) {\n      id\n      name\n      opt_in\n      opt_in_oct\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ALL_BLUE_SPACES_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject());
var INSERT_BLUE_SPACE_WITH_SCHOOL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject1());
var UPDATE_BLUE_SPACE_WITH_SCHOOL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject2());
var useAllBlueSpacesQuery = function() {
    var ref;
    var result = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(ALL_BLUE_SPACES_QUERY);
    var blueSpaces = (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.blue_spaces) || [];
    return _objectSpread({}, result, {
        blueSpaces: blueSpaces
    });
};
var useInsertBlueSpaceWithSchool = function() {
    var ref = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)(INSERT_BLUE_SPACE_WITH_SCHOOL), 1), insertBlueSpaceWithSchool = ref[0];
    return insertBlueSpaceWithSchool;
};
var useUpdateBlueSpaceWithSchool = function() {
    var ref = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)(UPDATE_BLUE_SPACE_WITH_SCHOOL), 1), insertBlueSpaceWithSchool = ref[0];
    return insertBlueSpaceWithSchool;
};


/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var _graphql_blueSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(819);
/* harmony import */ var _components_AppChrome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9395);
/* harmony import */ var _components_PageTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2866);
/* harmony import */ var _components_Map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(299);






function Home() {
    var blueSpaces = (0,_graphql_blueSpaces__WEBPACK_IMPORTED_MODULE_2__/* .useAllBlueSpacesQuery */ .dm)().blueSpaces;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_AppChrome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Our Blue \u2014 World Ocean Day for Schools"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageTitle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Our Blue"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Map__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                blueSpaces: blueSpaces
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [634,139,307,626,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);